exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--vgSwd {\n  padding: 0 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #5d5d5d;\n}\n\n.client--2UhfO {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 10px 5px;\n}\n\n.profile-icon--IQ-IV {\n  fill: white;\n  stroke: white;\n  -webkit-transform: scale3d(1.01, 1.01, 1.01);\n          transform: scale3d(1.01, 1.01, 1.01);\n}\n\n.controls--2vCzq {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.controls--2vCzq > * {\n  margin-right: 5px;\n}\n\n.controls--2vCzq > *:last-of-type {\n  margin-right: 0;\n}\n\n.name--1GB_U {\n  color: white;\n  font-size: 16px;\n  line-height: 18px;\n  font-weight: 400;\n  padding: 0 10px;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--vgSwd",
	"client": "client--2UhfO",
	"profile-icon": "profile-icon--IQ-IV",
	"controls": "controls--2vCzq",
	"name": "name--1GB_U"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/emission/client-summary/Company/Company.m.scss
// module id = 1457
// module chunks = 0